import React from 'react'
import { Link } from 'react-router-dom'
import './Analityka.scss'
import Laptop1 from '../Assets/Images/laptop1.webp'
import Laptop2 from '../Assets/Images/laptop2.webp'
import { useLanguage } from '../Contexts/LanguageContext'

const Analityka = () => {
    const { language } = useLanguage();

    return (
        <div className='analityka' id='analityka'>
            <h2>{language === 'polish' ? 'Analityka i jakość ruchu – dane w czasie rzeczywistym' : 'Analytics and Traffic Quality – Real-Time Data'}</h2>
            <h3>{language === 'polish' ? 'Dzięki AdCarrier masz natychmiastowy wgląd w to, skąd pochodzi ruch, jak angażują się klienci i które kampanie generują najlepsze wyniki.' : 'With AdCarrier, you have instant insight into where traffic comes from, how customers engage, and which campaigns generate the best results.'}</h3>
            <div className='content'>
                <div className='left'>
                    <div className='panel panel01'>
                        <img src={Laptop1} alt='laptop' className='laptop' />
                        <h3>{language === 'polish' ? 'Panel reklamodawcy' : 'Advertiser Panel'}</h3>
                        <p>
                            {language === 'polish' ? (
                                <>
                                    📈 Kliknięcia, wyświetlenia, rejestracje, CTR, ROI <br /><br />
                                    🗂️ GEO + urządzenie + język + źródło
                                </>
                            ) : (
                                <>
                                    📈 Clicks, impressions, registrations, CTR, ROI <br /><br />
                                    🗂️ GEO + device + language + source
                                </>
                            )}
                        </p>

                        <Link to='./login' >
                            <div className='clinknest-btn'>
                                <span>{language === 'polish' ? 'Załóż konto reklamodawcy' : 'Create Advertiser Account'}</span>
                            </div>
                        </Link>
                    </div>
                </div>
                <div className='right'>
                    <div className='panel panel02'>
                        <img src={Laptop2} alt='laptop' className='laptop' />
                        <h3>{language === 'polish' ? 'Panel wydawcy' : 'Publisher Panel'}</h3>
                        <p>
                            {language === 'polish' ? (
                                <>
                                    📈 Zarobki dzienne, eCPM, popularność kampanii <br /><br />
                                    🗂️ Śledzenie emisji reklam i błędów
                                </>
                            ) : (
                                <>
                                    📈 Daily earnings, eCPM, campaign popularity <br /><br />
                                    🗂️ Ad delivery and error tracking
                                </>
                            )}
                        </p>

                        <Link to='./login' >
                            <div className='clinknest-btn'>
                                <span>{language === 'polish' ? 'Załóż konto wydawcy' : 'Create Publisher Account'}</span>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Analityka